import React from 'react';
import moment from 'moment';

const DashboardEmbed = () => {
  // Function to get the most recent Monday's date
  const getMostRecentMonday = () => {
    const today = moment();
    const dayOfWeek = today.isoWeekday();
    const daysToSubtract = dayOfWeek === 1 ? 0 : dayOfWeek - 1;
    return today.subtract(daysToSubtract, 'days').format("MM-DD-YY");
  };

  // Setting the mondayTitle
  const mondayTitle = `Weekly-${getMostRecentMonday()}-Zirkle-Dashboard`;

  return (
    <div>
      <iframe
        width="960"
        height="720"
        src={`https://us-west-2.quicksight.aws.amazon.com/sn/embed/share/accounts/542664371176/dashboards/${mondayTitle}?directory_alias=vigilant-retroanalytics`}
        title="QuickSight Dashboard"
        style={{ border: 'none' }}
      ></iframe>
    </div>
  );
};

export default DashboardEmbed;
